import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveData } from '@angular/router';
import { SignupService } from './signup.service';
import { catchError, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SignupResolverService implements ResolveData{

  constructor(private signUpService: SignupService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.signUpService.getSubtenantData().pipe(
      catchError(error => {
        return of('No data');
      })
    );
  }
}
